import React from 'react';
import Icon from 'relements/build/esm/ui/icon';

import FlaggedIcon from '@src/components/Icon/flagged.svg';
import UnflaggedIcon from '@src/components/Icon/unflagged.svg';
import DisambiguationInactiveIcon from '@src/components/Icon/disambiguation-inactive.svg';
import DisambiguationActiveIcon from '@src/components/Icon/disambiguation-active.svg';
import UserResponseInput from './UserResponseInput';
import { getContextMenuOptions, getContextMenuPosition } from './_utils';

export default class UserResponse extends React.Component {
  render() {
    const { props } = this;
    const {
      userResponse,
      domainTitle,
      synonyms,
      updatedSynonyms,
      entities,
      updatedEntities,
      editedData,
      onToggle,
      readOnly,
      enterForNewLine,
      placeholder,
      className,
      disableMultipleWords,
      typingSuggestionsDisabled,
      updateCharLength = () => {},
      isNewPipeline,
      onFAQNode = false,
      onConnection = false,
    } = props;
    // we want only FAQ Node to show up the flag
    // in the rest of the cases, disambiguation is handled differently
    const isDisambiguationMessageCheck =
      isNewPipeline && userResponse.is_disambiguation_suggestion && onFAQNode;
    return (
      <div className={`user-response ${className}`}>
        {!isDisambiguationMessageCheck &&
        userResponse.is_typing_suggestion &&
        !typingSuggestionsDisabled ? (
          <Icon
            tooltipPosition="TOP"
            tooltip="Flagged"
            src={FlaggedIcon}
            className="user-response-flag-icon"
          />
        ) : null}
        {isDisambiguationMessageCheck ? (
          <Icon
            tooltipPosition="TOP"
            tooltip="Disambiguation Message"
            src={DisambiguationActiveIcon}
            className="user-response-flag-icon"
          />
        ) : null}
        <UserResponseInput
          {...userResponse}
          synonyms={synonyms}
          entities={entities}
          updatedSynonyms={updatedSynonyms}
          updatedEntities={updatedEntities}
          editedData={editedData}
          domainTitle={domainTitle}
          value={userResponse.title}
          onSelect={this._handleSelect}
          onDeselect={this._handleDeselect}
          onReturn={this._handleKeyUpFromNewResponse}
          onToggle={e => onToggle(userResponse)}
          readOnly={readOnly}
          enterForNewLine={enterForNewLine}
          placeholder={placeholder}
          updateCharLength={updateCharLength}
          disabled
          disableMultipleWords={disableMultipleWords}
          editorRef={editor => {
            this._editor = editor;
          }}
          onConnection={onConnection}
        />
        {this.renderUserResponseOptions(isDisambiguationMessageCheck)}
      </div>
    );
  }

  /**
   * renders different editing options for user response
   * @param {boolean} isDisambiguationMessageCheck checks whether a user response is marked as disambiguation message or not
   */
  renderUserResponseOptions = isDisambiguationMessageCheck => {
    const {
      showOnlyDisambiguation,
      readOnly,
      typingSuggestionsDisabled,
      userResponse,
      onFlag,
      isNewPipeline,
      onFAQNode,
      onFlagDisambiguation,
      onToggle,
    } = this.props;
    if (showOnlyDisambiguation) return null;

    let editIcon = null;
    if (!readOnly) {
      editIcon = (
        <Icon
          tooltipPosition="TOP"
          tooltip="Edit"
          src="edit"
          className="user-response-actions-icon no-pointer"
          onClick={() => this._editor.focus()}
        />
      );
    }

    let typingSuggestions = null;
    if (!typingSuggestionsDisabled) {
      typingSuggestions = (
        <Icon
          tooltipPosition="TOP"
          tooltip={`${!userResponse.is_typing_suggestion ? 'Flag' : 'Unflag'}`}
          src={!userResponse.is_typing_suggestion ? FlaggedIcon : UnflaggedIcon}
          className="user-response-actions-icon"
          onClick={() => onFlag(userResponse)}
        />
      );
    }

    return (
      <div className="user-response-actions">
        {editIcon}
        {typingSuggestions}
        {isNewPipeline && onFAQNode ? (
          <Icon
            tooltipPosition="TOP"
            tooltip={`${
              !isDisambiguationMessageCheck
                ? 'Add as Disambiguation'
                : 'Remove as Disambiguation'
            }`}
            src={
              !isDisambiguationMessageCheck
                ? DisambiguationActiveIcon
                : DisambiguationInactiveIcon
            }
            className="user-response-actions-icon"
            onClick={() => onFlagDisambiguation(userResponse)}
          />
        ) : null}
        <Icon
          tooltipPosition="TOP"
          tooltip={`${!userResponse.active ? 'Activate' : 'Deactivate'}`}
          src={userResponse.active ? 'invisible' : 'visible'}
          className="user-response-actions-icon"
          onClick={() => onToggle(userResponse)}
        />
      </div>
    );
  };

  _handleKeyUpFromNewResponse = text => {
    this.props.onEdit(this.props.userResponse, text);
    return 'handled';
  };

  _handleSelect = (selectedText, userResponse, selectedPosition) => {
    selectedText = selectedText.trim();
    if (selectedText.length > 0 && this.props.getWrapperRect) {
      this._showContextMenu(selectedText, userResponse, selectedPosition);
    }
  };

  _handleDeselect = e => {
    if (this.props.blurContextMenu) {
      this.props.blurContextMenu(e);
    }
  };

  _showContextMenu = (selectedText, userResponse, selectedPosition) => {
    const {
      domainTitle,
      onAddTag,
      onRemoveTag,
      onViewSynonyms,
      onSearchSynonyms,
      onToggleSynonyms,
      onToggleEntities,
      getWrapperRect,
      supportsTags,
      isNewPipeline,
      showOnlyDisambiguation = false,
    } = this.props;

    const contextMenuPosition = getContextMenuPosition(
      selectedPosition,
      getWrapperRect(),
      showOnlyDisambiguation,
      isNewPipeline
    );
    const contextMenuOptions = getContextMenuOptions(
      selectedText,
      userResponse,
      {
        addTag: onAddTag,
        removeTag: onRemoveTag,
        viewSynonyms: onViewSynonyms,
        searchSynonyms: onSearchSynonyms,
        toggleSynonyms: onToggleSynonyms,
        toggleEntities: onToggleEntities,
      },
      domainTitle,
      supportsTags
    );

    this.props.focusContextMenu(
      contextMenuOptions,
      contextMenuPosition,
      getWrapperRect()
    );
  };
}
